export default __webpack_public_path__ + "static/media/linkedin-icon.69e18da5.svg";